export const OWNER_FIELDS = ['id', 'email', 'first_name', 'last_name', 'team'];

export const COMPANY_FIELDS = ['hs_object_id', 'name', 'domain', 'industry', 'hubspot_owner_id', 'country', 'lifecyclestage'];